export const messages = {
  configurePageTitle: 'Configure Promotion',
  updatePageTitle: 'Update Promotion',
  subtitle: 'Build larger baskets through product and fuel discounts on the current transaction',
};
